// src/components/Communication/CommunicationsPage.jsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getSubNavForPage, getIndustryKey } from "../../constants/uiRegistry";
import InboxPage from "./Inbox/InboxPage";
import UnifiedInbox from "./Inbox/UnifiedInbox";
import SMSPage from "./SMS/SMSPage";
import CallsPage from "./Phone/PhonePage";
import EmailPage from "./Email/EmailPage";
import TemplatesPage from "./Templates/TemplatesPage";
import SequencesPage from "./Sequences/SequencesPage"; // start with inbox
import DialerPage from "./Dialer/DialerPage";
import CampaignsList from "../outreach/CampaignsList";
import { AuthContext } from "../../App";

/* Voice device init is app-global (Layout boots it silently for the
   incoming-call toast); the only explicit enable control lives on the
   Dialer. This page is just the comms tab switch. */

export default function CommunicationsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  const industry = getIndustryKey();
  const tabs = getSubNavForPage("/communication", industry);

  const [activeTab, setActiveTab] = useState(() => {
    const match = tabs.find(t => location.pathname.includes(t.path));
    return match?.key || "inbox";
  });

  useEffect(() => {
    if (!isAuthenticated) return navigate("/login");
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    const match = tabs.find(t => location.pathname.includes(t.path));
    if (match) setActiveTab(match.key);
  }, [location.pathname, tabs]);

  return (
    <div className="communications-page">
      {/* ⬇️ Conditional rendering for now — later move into router */}
      {/* NEW unified three-pane inbox. The legacy pages below stay live and
          routed until this is accepted — nobody gets stranded mid-build.
          Legacy inbox remains reachable at /communication/inbox-legacy. */}
      {activeTab === "inbox" && <UnifiedInbox />}
      {activeTab === "inbox-legacy" && <InboxPage />}
      {activeTab === "sms" && <SMSPage />}
      {activeTab === "calls" && <CallsPage />}
      {activeTab === "dialer" && <DialerPage />}
      {activeTab === "email" && <EmailPage />}
      {activeTab === "templates" && <TemplatesPage />}
      {activeTab === "sequences" && <SequencesPage />}
      {activeTab === "campaigns" && <CampaignsList />}
      {/* Add other tabs here later (SMSPage, CallsPage, etc) */}
    </div>
  );
}
